module.exports = __webpack_public_path__ + "mainassets/img/requiredOff.5bd034d2.svg";